exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * IE10 viewport hack for Surface/desktop Windows 8 bug\n * Copyright 2014-2015 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n\n/*\n * See the Getting Started docs for more information:\n * http://getbootstrap.com/getting-started/#support-ie10-width\n */\n@-ms-viewport     { width: device-width; }\n@-o-viewport      { width: device-width; }\n@viewport         { width: device-width; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/ggueret/Desktop/Personnel/Angular/ares-app/~/postcss-loader?{"ident":"postcss"}!/Users/ggueret/Desktop/Personnel/Angular/ares-app/src/bootstrap-carousel/ie10-viewport-bug-workaround.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/bootstrap-carousel/ie10-viewport-bug-workaround.css
// module chunks = 2